import React from "react";
import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import { SFDefaultUserProfile64 } from "../icons/base64Svgs";

const getSrc = (src) => {
  return src.includes("data:image/png;base64")
    ? src
    : `data:image/png;base64, ${src}`;
};

const SFAvatar = ({ name, src, defaultSrc, className }) => {
  if (src?.length > 0) {
    return (
      <Avatar
        {...(className && { className: className })}
        alt={name}
        src={getSrc(src)}
      />
    );
  } else {
    return (
      <Avatar
        {...(className && { className: className })}
        alt={name}
        src={
          defaultSrc
            ? getSrc(defaultSrc)
            : `data:image/png;base64, ${SFDefaultUserProfile64}`
        }
      />
    );
  }
};

SFAvatar.propTypes = {
  src: PropTypes.string,
  defaultSrc: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
};
export default SFAvatar;
